import { RemediationsController } from '../controller/RemediationsController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class RemediationsWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: RemediationsController,
    });
  }
}
